(() => {
  'use strict';
  const isEditor = Boolean(window.Shopify && window.Shopify.designMode);
  function getStore(key, session) {
    try { return (session ? sessionStorage : localStorage).getItem(key); } catch (_) { return null; }
  }
  function setStore(key, value, session) {
    try { (session ? sessionStorage : localStorage).setItem(key, value); } catch (_) {}
  }
  function mount(root) {
    if (root.dataset.dcwInitialized === '1') return;
    root.dataset.dcwInitialized = '1';
    const editor = isEditor || root.dataset.dcwEditor === 'true';
    const enabled = root.dataset.dcwEnabled === 'true';
    const sectionId = root.dataset.dcwSectionId;
    const get = selector => root.querySelector(selector);
    const overlay = get('[data-dcw-overlay]'), dialog = get('[data-dcw-dialog]');
    const launcher = get('[data-dcw-launcher]'), closeBtn = get('[data-dcw-close]');
    const spinBtn = get('[data-dcw-spin]'), spinLabel = get('[data-dcw-spin-label]');
    const disc = get('[data-dcw-disc]'), prizeSource = get('[data-dcw-prizes]');
    const play = get('[data-dcw-play]'), result = get('[data-dcw-result]');
    const winTitle = get('[data-dcw-result-title]'), coupon = get('[data-dcw-code]');
    const copyBtn = get('[data-dcw-copy]'), editorNote = get('[data-dcw-editor-note]');
    const unavailableNote = get('[data-dcw-unavailable]');
    if (![overlay,dialog,launcher,closeBtn,spinBtn,disc,prizeSource,play,result,winTitle,coupon,copyBtn].every(Boolean)) return;
    let prizes = [];
    try { prizes = JSON.parse(prizeSource.textContent.trim()); } catch (_) {}
    if (!Array.isArray(prizes)) prizes = [];
    const visualReady = prizes.length >= 2 && prizes.length <= 8;
    const couponsReady = visualReady && prizes.every(p =>
      Number.isInteger(p.discount) && p.discount >= 1 && p.discount <= 35 &&
      Number.isInteger(p.weight) && p.weight > 0 &&
      typeof p.code === 'string' && p.code.trim().length > 0
    );
    const readyForVisitors = enabled && couponsReady;
    if (editorNote) editorNote.textContent =
      !visualReady ? 'Adicione entre 2 e 8 prêmios para testar a roleta.' :
      !couponsReady ? 'Antes de ativar: preencha os códigos dos cupons e confira se são válidos na Yampi.' :
      !enabled ? 'Prévia liberada no editor. A roleta está desligada para visitantes.' :
      'Roleta habilitada. Faça uma compra de teste para validar o cupom.';
    if (!enabled && !editor) {
      launcher.hidden = true;
      return;
    }
    const idKey = 'dcw_winner_' + sectionId;
    const dismissedKey = 'dcw_dismissed_' + sectionId;
    const originalSpinLabel = spinLabel?.textContent || 'Girar roleta';
    const originalCopyLabel = copyBtn.textContent.trim();
    let spinning = false, rotation = 0, timer = null, lastFocus = null;
    let priorHtmlOverflow = '', priorBodyOverflow = '';
    const controller = new AbortController(), signal = controller.signal;
    let iconAnimation = null;
    async function startWheelIcon() {
      const icon = get('[data-dcw-lottie-icon]');
      const url = root.dataset.dcwIconJsonUrl;
      if (!icon || !url || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      try {
        if (!window.lottie?.loadAnimation) {
          if (!window.__dcwLottieLoadPromise) {
            window.__dcwLottieLoadPromise = new Promise((resolve, reject) => {
              const loader = document.createElement('script');
              loader.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.12.2/lottie.min.js';
              loader.async = true;
              loader.onload = () => window.lottie?.loadAnimation ? resolve(window.lottie) : reject(new Error('Lottie indisponível'));
              loader.onerror = () => reject(new Error('Falha ao carregar biblioteca Lottie'));
              document.head.appendChild(loader);
            }).catch(error => {
              window.__dcwLottieLoadPromise = null;
              throw error;
            });
          }
          await window.__dcwLottieLoadPromise;
        }
        if (!icon.isConnected || signal.aborted) return;
        const response = await fetch(url, {cache:'force-cache'});
        if (!response.ok) throw new Error('Falha no arquivo Lottie: ' + response.status);
        const data = await response.json();
        if (!icon.isConnected || signal.aborted) return;
        iconAnimation = window.lottie.loadAnimation({
          container:icon,renderer:'svg',loop:true,autoplay:true,
          animationData:data,rendererSettings:{preserveAspectRatio:'xMidYMid meet'}
        });
        iconAnimation.addEventListener('DOMLoaded', () => {
          const fallback = icon.querySelector('.dcw-icon-fallback');
          if (fallback) fallback.remove();
        });
      } catch (error) {
        // Keep the accessible static fallback icon if an external dependency fails.
        if (iconAnimation) { try { iconAnimation.destroy(); } catch (_) {} iconAnimation = null; }
      }
    }
    startWheelIcon();
    function getWinner() {
      const saved = getStore(idKey, false);
      if (!saved) return null;
      try {
        const val = JSON.parse(saved);
        return prizes.find(p => p.discount === val.discount && p.code === val.code) || null;
      } catch (_) { return null; }
    }
    function playScreen() {
      play.hidden = false;
      result.hidden = true;
      spinBtn.disabled = !visualReady || (!editor && !couponsReady);
      if (unavailableNote) unavailableNote.hidden = editor || couponsReady;
      if (spinLabel) spinLabel.textContent = originalSpinLabel;
    }
    function resultScreen(p) {
      play.hidden = true;
      result.hidden = false;
      winTitle.textContent = 'Você ganhou ' + p.discount + '% OFF!';
      coupon.textContent = p.code || (editor ? 'CUPOM DE TESTE' : '');
      copyBtn.textContent = originalCopyLabel;
      copyBtn.disabled = !coupon.textContent.trim();
      requestAnimationFrame(() => copyBtn.focus());
    }
    function open() {
      if (!overlay.hidden) return;
      lastFocus = document.activeElement;
      priorHtmlOverflow = document.documentElement.style.overflow;
      priorBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      overlay.hidden = false;
      const winner = editor ? null : getWinner();
      if (winner) resultScreen(winner);
      else playScreen();
      requestAnimationFrame(() => closeBtn.focus());
    }
    function close() {
      if (spinning || overlay.hidden) return;
      overlay.hidden = true;
      document.documentElement.style.overflow = priorHtmlOverflow;
      document.body.style.overflow = priorBodyOverflow;
      if (!editor) setStore(dismissedKey, '1', true);
      if (lastFocus?.isConnected && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    function randomFloat() {
      if (window.crypto?.getRandomValues) {
        const number = new Uint32Array(1);
        window.crypto.getRandomValues(number);
        return number[0] / 4294967296;
      }
      return Math.random();
    }
    function pickWinner(pool) {
      const total = pool.reduce((acc,p) => acc + p.weight, 0);
      let value = randomFloat() * total;
      for (const p of pool) {
        value -= p.weight;
        if (value < 0) return p;
      }
      return pool[pool.length - 1];
    }
    function onSpin() {
      if (spinning || !visualReady) return;
      if (!editor) {
        const previous = getWinner();
        if (previous) { resultScreen(previous); return; }
        if (!readyForVisitors) return;
      }
      const pool = editor && !couponsReady ?
        prizes.map(p => ({...p, code:p.code || 'CUPOM DE TESTE'})) : prizes;
      const selected = pickWinner(pool);
      if (!selected) return;
      if (!editor) setStore(idKey, JSON.stringify({discount:selected.discount,code:selected.code}), false);
      spinning = true;
      spinBtn.disabled = true;
      if (spinLabel) spinLabel.textContent = 'Girando...';
      const slice = 360 / pool.length;
      const target = (((-((selected.index + .5) * slice)) % 360) + 360) % 360;
      const current = ((rotation % 360) + 360) % 360;
      rotation += 2160 + ((target - current + 360) % 360);
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      disc.style.transitionDuration = reduce ? '.1s' : '5.2s';
      disc.style.transform = 'rotate(' + rotation + 'deg)';
      timer = setTimeout(() => {
        spinning = false;
        resultScreen(selected);
      }, reduce ? 170 : 5290);
    }
    async function onCopy() {
      const value = coupon.textContent.trim();
      if (!value) return;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Unavailable');
        await navigator.clipboard.writeText(value);
        copyBtn.textContent = 'Cupom copiado!';
      } catch (_) {
        const range = document.createRange();
        range.selectNodeContents(coupon);
        const selection = getSelection();
        selection?.removeAllRanges();
        selection?.addRange(range);
        copyBtn.textContent = 'Selecione e copie o código';
      }
    }
    function keyboard(event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
      if (event.key !== 'Tab') return;
      const list = [...dialog.querySelectorAll('button:not(:disabled),a[href],summary')].filter(el =>
        el.getClientRects().length > 0 && !el.closest('[hidden]')
      );
      if (!list.length) { event.preventDefault(); dialog.focus(); return; }
      const first = list[0], last = list[list.length-1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    launcher.addEventListener('click', open, {signal});
    closeBtn.addEventListener('click', close, {signal});
    overlay.addEventListener('click', event => {
      if (event.target === overlay) close();
    }, {signal});
    spinBtn.addEventListener('click', onSpin, {signal});
    copyBtn.addEventListener('click', onCopy, {signal});
    document.addEventListener('keydown', keyboard, {signal});
    document.addEventListener('shopify:section:select', event => {
      if (event.detail?.sectionId === sectionId) open();
    }, {signal});
    document.addEventListener('shopify:block:select', event => {
      if (event.target?.closest('.shopify-section')?.contains(root)) open();
    }, {signal});
    document.addEventListener('shopify:section:unload', event => {
      if (event.detail?.sectionId !== sectionId) return;
      clearTimeout(timer);
      spinning = false;
      close();
      controller.abort();
      if (iconAnimation) { try { iconAnimation.destroy(); } catch (_) {} iconAnimation = null; }
    }, {signal});
    // Reveal only after all event handlers have been registered.
    root.dataset.dcwInteractive = 'true';
    if (!editor && readyForVisitors && !getStore(dismissedKey,true) && !getWinner()) {
      timer = setTimeout(open, Math.min(15000,Math.max(0,Number(root.dataset.dcwDelay)||0)));
    }
  }
  const initialize = () => document.querySelectorAll('[data-dcw-root]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();